/** 트리 들여쓰기·탐색기 행 메타 (PanelPlanning TreeNodeRow) */
export const PANEL_TREE_GUIDE_WIDTH_PX = 14;
export const PANEL_TREE_CHEVRON_SLOT_PX = 28;

/**
 * @param {string} type - array | string | module
 * @param {{ expanded?: boolean, hasChildren?: boolean }} [opts]
 */
export function getPanelTreeRowMeta(type, opts = {}) {
  const { expanded = false, hasChildren = false } = opts;

  switch (type) {
    case 'array':
      return {
        icon: hasChildren && expanded ? 'mdi-folder-open-outline' : 'mdi-folder-outline',
        iconColor: '#FF9800',
        labelKey: 'panelPlanning.treeTypeArray',
        nameClass: 'tree-row-name--array font-weight-medium',
        showTypeChip: true,
        iconClass: ''
      };
    case 'string':
      return {
        icon: 'mdi-vector-square',
        iconColor: '#1E88E5',
        labelKey: 'panelPlanning.treeTypeString',
        nameClass: 'tree-row-name--string',
        showTypeChip: true,
        iconClass: ''
      };
    case 'module':
      return {
        icon: 'mdi-solar-panel',
        iconColor: '#00897B',
        labelKey: 'panelPlanning.treeTypeModule',
        nameClass: 'tree-row-name--module font-weight-light',
        showTypeChip: true,
        iconClass: 'tree-type-icon--module'
      };
    default:
      return {
        icon: 'mdi-file-outline',
        iconColor: 'grey',
        labelKey: '',
        nameClass: '',
        showTypeChip: true,
        iconClass: ''
      };
  }
}
